<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    imageUrl?: string | null;
    interactive?: boolean;
  }>(),
  {
    imageUrl: null,
    interactive: false,
  },
);

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();
</script>

<template>
  <button
    v-if="imageUrl && interactive"
    v-bind="$attrs"
    type="button"
    :class="['block aspect-square appearance-none border-0 bg-cover bg-center bg-no-repeat p-0']"
    :style="{ backgroundImage: `url(${imageUrl})` }"
    @click="emit('click', $event)"
  ></button>
  <div
    v-else-if="imageUrl"
    v-bind="$attrs"
    :class="['aspect-square bg-cover bg-center bg-no-repeat']"
    :style="{ backgroundImage: `url(${imageUrl})` }"
  ></div>
</template>
